import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APIService } from 'src/app/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ProductDetailComponent } from '../product-detail/product-detail.component';
import * as xlsx from 'xlsx';
import { SelectStoreComponent } from '../select-store/select-store.component';
import { Observable } from 'rxjs';
import { category, subCategory } from '../item-entry/item-entry.component';

@Component({
  selector: 'app-stock-expand',
  templateUrl: './stock-expand.component.html',
  styleUrls: ['./stock-expand.component.scss']
})
export class StockExpandComponent implements OnInit {

  dataSource = new MatTableDataSource();
  jarvisData: any = [];
  agencyData: any = [];
  Items: any = [];
  categories: any = [];
  subCategoryList: subCategory[] = [];
  storeList: any = [];
  selectedStoreQty: any = [];
  UnitList: any = [];
  hsnList: any = [];
  copyItems: any = [];
  tagData: any = [];
  Category: any = [];
  category: any = [];
  tag: any = [];
  selectedTags: any = [];
  // IncludeZeroqtyItms: any = [];
  // categoryCtrl = new FormControl();
  // subCategoryCtrl = new FormControl();
  // filteredCategory!: Observable<category[]>;
  // filteredsubCategoryList!: Observable<subCategory[]>;
  // displayedColumns: string[] = ['ItemName', 'ItemCode', 'CatSubCatName', 'CurrQty', 'MinStockQty', 'SKU', 'ValStdCost',  'DefSaleRate',  'DefPurchRate', 'DefStockRate', 'DefGSTRate', 'HSN', 'LeadTime',  'Tags', 'Notes'];//'Actions'
  displayedColumns: string[] = ['ItemName', 'ItemCode', 'Imp', 'CatSubCatName','MinStockQty', 'CurrQty', 'SKU', 'DefStockRate', 'DefSaleRate',  'DefPurchRate', 'LastPurchRate', 'ValLPP', 'HSN', 'DefGSTRate',  'LeadTime',  'Tags', 'Notes'];//'Actions'
  itemTag = {
    search: ''
  };

  filterValues = {
    ItemName: '',
    ItemCode: '',
    Category: '',
    CurrQty: '',
    Imp: '',
    SKU: '',
    StockValue: '',
    DefStockRate: '',
    DefGSTRate: '',
    DefPurchRate: '',
    LastPurchRate: '',
    ValLPP: '',
    DefSaleRate: '',
    ValStdCost: '',
    HSN: '',
    LeadTime: '',
    MinStockQty: '',
    Tags: ''
  };

  storeId: any = 0
  modalReference: any;
  filter: any = 0;
  totalValue: any = 0;

  ItemNameFilter = new FormControl('');
  ItemCodeFilter = new FormControl('');
  CategoryFilter = new FormControl('');
  ImpFilter = new FormControl('');
  CurrQtyFilter = new FormControl('');
  SKUFilter = new FormControl('');
  StockValueFilter = new FormControl('');
  DefStockRateFilter = new FormControl('');
  GstValueFilter = new FormControl('');
  purchRateFilter = new FormControl('');
  saleRateFilter = new FormControl('');
  stdCostFilter = new FormControl('');
  HSNFilter = new FormControl('');
  leadTimeFilter = new FormControl('');
  minStockFilter = new FormControl('');
  tagFilter = new FormControl('');
  IncludeZeroqtyItms: any = [];
  depletedItems: any = false;
  zeroQtyItems: any = false;
  isRateView: Boolean = false;
  invRights: any = [];


  closeResult: any;
  search: string = '';
  storeName: any = 'All Stores';
  exportToExcel: any = [];
  allStoreRights: boolean = true;
  currValuation: number = 0;
  showLearningMaterial: boolean = false;
  isWeb: boolean = true;
  showOnBoarding: boolean = false;

  //modalReference: any;
  selected: any = {
    imp: 3,
    stockType: 0,
  };


  @ViewChild('epltable', { static: false }) epltable!: ElementRef;
  ItemName: any;
  data: any = {
    categoryID: '0',
    subCategory: '',
    SubCategoryID: '0',
    category: '',
  };
  isDataFilter: boolean = false
  //@ViewChild(MatSort) sort: MatSort | any;

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.matSort;
    this.dataSource.paginator = this.paginator;
  }

  constructor(private apiService: APIService, public CmnService: CommonService, private modalService: NgbModal,) {

    let agencyData = this.apiService.getCookie("M");
    let tagData = this.apiService.getCookie("ERP_Cfg");

    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      var PremiumTillDT = this.agencyData[0].PremiumTillDT;
      if (new Date(PremiumTillDT) < new Date() || !PremiumTillDT || PremiumTillDT == null) {
        window.location.href = "main.html#/home";
        return;
      }
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let invRights = this.apiService.getCookie("J");
    if(invRights){
      this.invRights = JSON.parse(invRights);
      let ownUserID: number = this.jarvisData[0].UserID;
      this.invRights = $.grep( this.invRights, function(o: any){ return o.UserID == ownUserID })[0];

       if(!this.invRights.Inv && !this.invRights.InvCfg && !this.invRights.InvMstrs && !this.invRights.InvRpts && !this.invRights.InvXns){
        window.location.href = "../../main.html#/home";
         return;
       }

      if(this.invRights.InvRateView.toString() != "undefined"){
          this.isRateView = this.invRights.InvRateView;
        }
      
    }

    if (tagData) {
      this.tagData = JSON.parse(tagData)
      this.Category = this.tagData
    }

    this.category = JSON.parse(this.Category[0].ItemCategories);
    this.currValuation = this.tagData[0].ValnMethod;
    this.tag = this.tagData[0].ItemTags.split(',');
    this.tag = this.tag.filter((a: any) => a != '');
    this.tag = this.tag.sort((a: any, b: any) => a.localeCompare(b));
  }
  ngOnInit(): void {
    this.ItemNameFilter.valueChanges
      .subscribe(
        NameFilter => {
          this.filterValues.ItemName = NameFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.ItemCodeFilter.valueChanges
      .subscribe(
        OpBalFiltert => {
          this.filterValues.ItemCode = OpBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.CategoryFilter.valueChanges
      .subscribe(
        CrAmtFilter => {
          this.filterValues.Category = CrAmtFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.ImpFilter.valueChanges
      .subscribe(
        ImpFilter => {
          this.filterValues.Imp = ImpFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.CurrQtyFilter.valueChanges
      .subscribe(
        DbAmtFilter => {
          this.filterValues.CurrQty = DbAmtFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
      // this.CurrQtyFilter.valueChanges
      // .subscribe(
      //   DbAmtFilter => {
      //     this.filterValues.CurrQty = DbAmtFilter;
      //     this.dataSource.filter = JSON.stringify(this.filterValues);
      //   }
      // )
    this.SKUFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.SKU = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.StockValueFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.StockValue = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.DefStockRateFilter.valueChanges
      .subscribe(
        CloBalFiltert => {
          this.filterValues.DefStockRate = CloBalFiltert;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.GstValueFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.DefGSTRate = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.purchRateFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.DefPurchRate = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.saleRateFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.DefSaleRate = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.stdCostFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.ValStdCost = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.HSNFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.HSN = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.leadTimeFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.LeadTime = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.minStockFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.MinStockQty = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.tagFilter.valueChanges.subscribe(
      CloBalFiltert => {
        this.filterValues.Tags = CloBalFiltert;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )

    this.isWeb = this.apiService.apiCheckWeb();
    this.showLearningMaterial = this.CmnService.checkShowLearningMaterial();
    this.showOnBoarding = this.CmnService.checkShowOnBoarding();
    //this.getData(); // 2024-09-28 - ES: Try removing this
    this.getAllConfig();
  }

  

  getData() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data = [{
      StatusID: 1,
      StoreID: this.storeId
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getItem',
      moduleID: 5,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successRespItem.bind(this), this.failureRespItem.bind(this));
  }

  successRespItem(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);

        if (reponseData.Table[0].ErrCode == 1000) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg)
        } else {
          if (reponseData) {
            let data = reponseData;
            //this.dataSource.data = data.Table1;
            this.Items = data.Table1;

            this.Items.forEach((element: any) => {
              element.Tags = element.Tags.endsWith(",") ? element.Tags.slice(0, -1) : element.Tags;
              element.ImpName = (element.ImportanceID == 0 ? 'Low' : (element.ImportanceID == 1 ? 'High' : 'Normal'));
            });

            for (let x = 0; x < this.Items.length; x++) {
              if (this.Items[x].StoreBatches) {
                let tempData = JSON.parse(this.Items[x].StoreBatches)
                let tempQTY = tempData.filter((x: any) => x.SID == this.storeId)
                if (tempQTY.length > 0) {
                  this.Items[x].CurrQty = Number(tempQTY[0].Q).toFixed(this.Items[x].SKUPrecision)
                } else {
                  this.Items[x].CurrQty = 0
                }
              }  
            }

            this.Items.map((o: any) => (
             //  o.CurrQty = Number(o.CurrQty).toFixed(o.SKUPrecision),
               o.categoryName = ((o.CategoryID == 0 ? '' : this.category.filter((i: any) => i.cid == o.CategoryID).length > 0 ? (o.CategoryID == 0 ? '' : this.category.filter((i: any) => i.cid == o.CategoryID)[0].cnm) : '')),
               o.subCategoryName = ((o.CategoryID == 0 || o.SubCategoryID == 0) ? '' : (this.category.filter((i: any) => i.cid == o.CategoryID).length > 0 ? this.category.filter((i: any) => i.cid == o.CategoryID)[0].sub.filter((j: any) => j.sid == o.SubCategoryID): ''))));
            this.IncludeZeroqtyItms = this.Items
            this.copyItems = this.Items;
            if (this.zeroQtyItems == false){
            this.Items = this.Items.filter((x: any) => x.CurrQty > 0);
            }
            this.dataSource.data = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))
            
            // this.IncludeZeroqtyItms = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))
           
            this.dataSource.paginator = this.paginator;
            this.exportToExcel = this.Items;
            this.dataSource.sort = this.matSort;
            this.totalValue = 0;
            if (this.currValuation > 0) {
              for (let i = 0; i < this.Items.length; i++) {
                //this.totalValue = this.totalValue + this.Items[i].TotalValue
                this.totalValue = (this.totalValue + (this.currValuation == 1 ? this.Items[i].ValStdCost : this.currValuation == 2 ? this.Items[i].ValLPP : this.Items[i].ValHistAvg));
              }
            } else {
              var total = this.Items.map((item: any) => Number(item.DefStockRate) * Number(item.CurrQty));
              this.totalValue = total.reduce(function (a: any, b: any) { return a + b; });    
            }  
          }

          // if (reponseData) {
          //   let data = reponseData;
          //   let tempItems = data.Table1;
          //   this.Items = tempItems.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));
            
          //   for (let x = 0; x < this.Items.length; x++) {
          //     if (this.Items[x].StoreBatches) {
          //       let tempData = JSON.parse(this.Items[x].StoreBatches)
          //       let tempQTY = tempData.filter((x: any) => x.SID == this.storeId)
          //       if (tempQTY.length > 0) {
          //         this.Items[x].CurrQty = Number(tempQTY[0].Q).toFixed(this.Items[x].SKUPrecision)
          //       } else {
          //         this.Items[x].CurrQty = 0
          //       }
          //     } else {
          //       this.Items[x].CurrQty = Number(this.Items[x].CurrQty).toFixed(this.Items[x].SKUPrecision)
          //     }
          //     this.Items[x].TotalValue = Number(this.Items[x].CurrQty) * Number(this.Items[x].DefStockRate)
          //     if (this.Items[x].CategoryID > 0) {
          //       for (let i = 0; i < this.categories.length; i++) {
          //         if (this.Items[x].CategoryID == this.categories[i].cid) {
          //           if(this.categories[i].cnm){
          //             this.Items[x].CategoryName = this.categories[i].cnm;
          //           }
          //           else{
          //             this.Items[x].CategoryName = '';
          //           }
          //           let subCategory = this.categories.filter((A: any) => A.cid == this.Items[x].CategoryID)
          //           let tempSubCat = subCategory[0].sub.filter((s: any) => s.sid == this.Items[x].SubCategoryID)
          //           if (tempSubCat.length > 0) {
          //             this.Items[x].SubCategoryName = tempSubCat[0].snm
          //           }
          //           else {
          //             this.Items[x].SubCategoryName = ''
          //           }
          //         }
          //       }
          //     }
          //     else {
          //       this.Items[x].CategoryName = ''
          //     }  
          //     this.Items[x].CatSubCatName = (this.Items[x].CategoryName == '' ? '-' : this.Items[x].CategoryName) + (this.Items[x].SubCategoryName ? ' / ' : '') + (this.Items[x].SubCategoryName ? this.Items[x].SubCategoryName : '');
          //   }
          //   this.IncludeZeroqtyItms = this.Items;   
          //   this.Items = this.Items.filter((x: any) => x.CurrQty > 0);
          //   this.copyItems = this.Items;
  
          //   this.dataSource = new MatTableDataSource(this.Items);
          //   this.exportToExcel = this.Items;
            
          //   this.dataSource.paginator = this.paginator;
          //   this.dataSource.sort = this.matSort;
  
          //   this.totalValue = 0;
          //   for (let i = 0; i < this.Items.length; i++) {  
          //     this.totalValue = this.totalValue + this.Items[i].TotalValue
          //   }
  
          //   this.getTagSearchData(2);
          //   this.typeFilter(this.filter);
          // }
        }
      }
    }
  }

  //failureResp - failure handler
  failureRespItem(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  openItemEidt(content: any, obj: any) {
    // this.ItemID = obj
    this.modalReference = this.modalService.open(ProductDetailComponent, { windowClass: obj.IsMade ? 'modal-item-Edit' : 'modal-item-EditOne', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.ItemID = obj.ItemID;
    this.modalReference.componentInstance.mdlRef = this.modalReference;

    this.modalReference.result.then((result: any) => {
      if (result.action == 'Done') {
        this.getData();
      }
    })
  }



exportToExcelActivities() {
  var html = "";
  // Title
  html += "<table><tr>";
  html += "<th style='text-align: left;'>Stock Expand</th>"
  html += "</table></tr>"; 

  html += "<table><tr></table></tr>";
  html += "<table><tr>";
  var usage = this.filter == 0 ? 'All' : this.filter == 1 ? 'Products' : this.filter == 2 ? 'Materials' : this.filter == 3 ? 'Spares' : this.filter == 4 ? 'Assemblies' : 'All';
  var zero = (this.depletedItems == false && this.zeroQtyItems == false) ? '' : this.depletedItems == true ? 'Show Depleted Items' : 'Include Zero Qty Items'
  html += "<p><b>View : </b>" + usage + (zero != '' ? '<b>, ' + zero + ' :</b>  Yes' : '') + "</p>"
  html += "</table></tr>";

  html += "<table><tr>";
  var strHeader = ""
  strHeader += "<th style='text-align: left;'>Item</th>";
  strHeader += "<th style='text-align: left;'>Code</th>";
  strHeader += "<th style='text-align: left;'>Category</th>";
  strHeader += "<th style='text-align: right;'>Min.</th>";
  strHeader += "<th style='text-align: right;'>Qty</th>";

  strHeader += "<th style='text-align: left;'>Unit</th>";
  // strHeader += "<th style='text-align: right;'>Std Cost</th>";
  if(this.isRateView){
    strHeader += "<th style='text-align: right;'>Rate</th>";
    strHeader += "<th style='text-align: right;'>Sale Price</th>";
    strHeader += "<th style='text-align: right;'>Pur.Cost</th>";
    strHeader += "<th style='text-align: right;'>LastPurchRate</th>";
    strHeader += "<th style='text-align: right;'>" + (this.currValuation == 1 ? 'SC' : (this.currValuation == 2 ? 'LLP' : (this.currValuation == 3 ? 'HA' : 0))) + " Value</th>";
  }
 

  // strHeader += "<th style='text-align: right;'>Rate</th>";
  strHeader += "<th style='text-align: right;'>HSN</th>";
  if(this.isRateView){
    strHeader += "<th style='text-align: right;'>GST</th>";
  }

  
  strHeader += "<th style='text-align: right;'>Lead Time</th>";
  strHeader += "<th style='text-align: left;'>Tags</th>";
  strHeader += "<th style='text-align: left;'>Notes</th>";

  strHeader += "</tr>"
  html += strHeader;
  var body = "";
  this.exportToExcel.forEach((item:any, key:any) => {
    let itemValue: number = 0;
    itemValue = (this.currValuation == 1 ? item.ValStdCost : (this.currValuation == 2 ? item.ValLPP : (this.currValuation == 3 ? item.ValHistAvg : 0)))
    body += "<tr>";
    body += "<td style='text-align: left;'>" + item.ItemName + "</td>";
    body += "<td style='text-align: left;'>" + item.ItemCode + "</td>";
    if(item.categoryName != '' && item.subCategoryName.length > 0){
      body += "<td style='text-align: left;'>" + item.categoryName + "/ " + item.subCategoryName[0].snm + "</td>";
    }
    if(item.categoryName == '' && item.subCategoryName.length > 0){
      body += "<td style='text-align: left;'>" + '-' + "</td>";
    }
    if(item.categoryName == '' && item.subCategoryName == ''){
      body += "<td style='text-align: left;'>" + '-' + "</td>";
    }
    if(item.categoryName != '' && item.subCategoryName == ''){
      body += "<td style='text-align: left;'>" + item.categoryName + "</td>";
    }
    
    // body += "<td style='text-align: left;'>" + (item.CatSubCatName ? item.CatSubCatName : '-') + "</td>";
    body += "<td style='text-align: right;'>" +  item.MinStockQty + "</td>";
    body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.CurrQty + "</td>";
    body += "<td style='text-align: left;'>" +  item.SKU + "</td>";
    // body += "<td style='text-align: right;'>" +  item.ValStdCost + "</td>";
    if(this.isRateView){
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.DefStockRate + "</td>";
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.DefSaleRate + "</td>";
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.DefPurchRate + "</td>";
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" +  item.LastPurchRate + "</td>";
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + itemValue + "</td>";  
      //body += "<td style='text-align: right;'>" +  item.ValLPP + "</td>";
    }
    body += "<td style='text-align: right;'>" +  item.HSN + "</td>";
    if(this.isRateView){
      body += "<td style='text-align: right;'>" +  item.DefGSTRate + "</td>";
    }
    body += "<td style='text-align: right;'>" +  item.LeadTime + "</td>";
    body += "<td style='text-align: left;'>" +  item.Tags + "</td>";
    body += "<td style='text-align: left;'>" +  (item.Details ? item.Details : '-') + "</td>";

    // body += "<td style='text-align: right;'>" +  (this.myCurrency.code == 'INR' ? Number(item.DefStockRate).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,') : Intl.NumberFormat('en-US').format(item.DefStockRate)) + "</td>";
    // body += "<td style='text-align: right;'>" +  (this.myCurrency.code == 'INR' ? Number(itemValue).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,') : Intl.NumberFormat('en-US').format(itemValue)) + "</td>";

  body += "</tr>";
  })
  html += body;
  html += "</table>";
  this.tableToExcel(html, 'Sheet1', 'StockExpand');
}


  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        //window.location.href = uri + base64(format(template, ctx))
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()





  openQty(content: any, strBatch: any, id: number) {
    let item = [];
    if (this.zeroQtyItems) {
      item = this.IncludeZeroqtyItms.filter((x: any) => x.ItemID == id);
    } else {
      item = this.Items.filter((x: any) => x.ItemID == id);
    }

    if(item.length > 0){
      this.ItemName = item[0].ItemName;
    }

    if ((this.storeId == 0) && (!strBatch)) {
      this.getProductDetail(id, content);
    }

    if (strBatch) {

      this.modalReference = this.modalService.open(content, { windowClass: 'qty-edit', backdrop: 'static', keyboard: false });
      this.selectedStoreQty = [];

      let tmpstrQty = JSON.parse(strBatch);
      let obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };

      // for(let s = 0; s < this.storeList.length; s++) {
      //   for(let q = 0; q < tmpstrQty.length; q++) {
      //     let tmpArr = this.selectedStoreQty.filter((x: any) => { return x.StrID == this.storeList[s].StrID });
      //     obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };

      //     if((tmpArr.length == 0) && (this.storeList[s].StrID == tmpstrQty[q].SID)) {
      //       if(this.storeList[s].StrID === tmpstrQty[q].SID) {
      //         obj.name = this.storeList[s].sNm;
      //         obj.qty = Number(tmpstrQty[q].Q).toFixed(item[0].SKUPrecision);
      //         obj.ItemID = id;
      //         obj.StrID = this.storeList[s].StrID;
      //         obj.unit = item[0].SKU;
      //         obj.prec = item[0].SKUPrecision;
      //         this.selectedStoreQty.push(obj);
      //       }
      //     }
      //     else {
      //       obj.name = this.storeList[s].sNm;
      //       obj.qty = '0';
      //       obj.ItemID = id;
      //       obj.StrID = this.storeList[s].StrID;
      //       obj.unit = item[0].SKU;
      //       obj.prec = item[0].SKUPrecision;
      //       this.selectedStoreQty.push(obj);
      //     }
      //   }
      // }

      // for(let s = 0; s < this.storeList.length; s++) {
      //   for(let q = 0; q < tmpstrQty.length; q++) {
      //     obj = { name: '', qty: '0', ItemID: 0, StrID: 0, isEdit: false, unit: '', prec: 0 };
      //     if(this.storeList[s].StrID == tmpstrQty[q].SID) {
      //       obj.name = this.storeList[s].sNm;
      //       obj.qty = Number(tmpstrQty[q].Q).toFixed(item[0].SKUPrecision);
      //       obj.ItemID = id;
      //       obj.StrID = this.storeList[s].StrID;
      //       obj.unit = item[0].SKU;
      //       obj.prec = item[0].SKUPrecision;
      //       this.selectedStoreQty.push(obj);
      //       break;
      //     }
      //     else {
      //       obj.name = this.storeList[s].sNm;
      //       obj.qty = '0';
      //       obj.ItemID = id;
      //       obj.StrID = this.storeList[s].StrID;
      //       obj.unit = item[0].SKU;
      //       obj.prec = item[0].SKUPrecision;
      //       this.selectedStoreQty.push(obj);
      //       break;
      //     }
      //   }
      // }

      for (let s = 0; s < this.storeList.length; s++) {
        let stores = this.storeList[s];
        let currStore = $.grep(tmpstrQty, function (o: any) { return o.SID == stores.StrID });
        let storeQty = 0;
        if (currStore.length > 0) {
          storeQty = currStore[0].Q;
        }

        this.selectedStoreQty.push({
          name: stores.sNm,
          qty: Number(storeQty).toFixed(item[0].SKUPrecision),
          ItemID: id,
          StrID: stores.StrID,
          unit: item[0].SKU,
          prec: item[0].SKUPrecision
        });
      }

      this.selectedStoreQty = this.selectedStoreQty.sort((a: any, b: any) => a.name.localeCompare(b.name))
    }
  }

  //qty with prcn
  enterQty = (s: any) => {
    s.qty = this.CmnService.PrecisionwiseValue(s.qty, s.prec)
  }


  getProductDetail(id: number, content: any) {

    let data = [{
      productID: id
    }]

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 4,
      data: JSON.stringify(data)
    }];

    return this.apiService.getData(myParams, this.successResp.bind(this, content, id), this.failureResp.bind(this));
  }

  failureResp(res: any) {

    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successResp(content: any, id: number, res: any) {

    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
          // this.router.navigateByUrl('/Stock');
        }
        else {
          let productData = reponseData.Table[0];

          let StoreBatches = productData.StoreBatches;
          this.openQty(content, StoreBatches, id);
        }
      }
    }
  }

  getAllConfig() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data: any = []

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'getConfig',
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successRespGet.bind(this), this.failureRespGet.bind(this));
  }

  //failureResp - failure handler
  failureRespGet(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successRespGet(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let configData = reponseData.Table2;
          if (configData[0].Stores) {
            this.storeList = JSON.parse(configData[0].Stores)
            this.UnitList = JSON.parse(configData[0].Units)
            this.hsnList = JSON.parse(configData[0].HSNSAC)
            this.categories = JSON.parse(configData[0].ItemCategories)
            // this.storeId = this.storeList[0].StrID
            // this.storeName = this.storeList[0].sNm;

            // For Limited Store Rights
            let myStores: any = [];
            if(this.jarvisData[0].UserID != this.agencyData[0].AdminUserID) {
              for(let i: number = 0; i < this.storeList.length; i++){
                if(this.storeList[i].UIDs){
                  let selectedUsers = String(this.storeList[i].UIDs).split(",");
                  for(let j: number = 0; j < selectedUsers.length; j++){
                    if(selectedUsers[j] == this.jarvisData[0].UserID){
                      myStores.push(this.storeList[i]);
                    }
                  }                
                }
                else{
                  myStores.push(this.storeList[i]);
                }
              }
              if(myStores.length != this.storeList.length){
                this.storeId = myStores.length > 0 ? myStores[0].StrID : 0;
                this.storeName = myStores.length > 0 ? myStores[0].sNm : '';
                this.allStoreRights = false;
                this.zeroQtyItems = false;
              }
            }

            if (myStores.length > 0 || this.jarvisData[0].UserID == this.agencyData[0].AdminUserID) {
              this.getData();  
            }

            

          }
        }

      }
    }
  }

  saveReconcile(obj: any) {
    //obj.isEdit = false;

    let MyLastSyncDT = localStorage.getItem("MyLastSyncDT");

    let data = [{
      'ItemID': obj.ItemID,
      'StoreID': obj.StrID,
      'NewQty': obj.qty
    }];

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: MyLastSyncDT,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'Reconcile',
      moduleID: 5,
      data: JSON.stringify(data)
    }];
    this.apiService.sendChange(myParams, this.successReconcile.bind(this, obj), this.failureReconcile.bind(this, obj));

  }

  successReconcile(obj: any, res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          obj.isEdit = false;
          this.getData();
        }
      }
    }
  }

  //successResp - success get handler
  failureReconcile(obj: any, res: any) {
    if (res.error) {
      console.log(res.message);
    }
  }


  typeFilter = (obj: any) => {
    var copyItems = this.IncludeZeroqtyItms //this.copyItems
    var tempItem = [];
    this.filter = obj
    if (obj == 0) {
      tempItem = copyItems;
    }
    else if (obj == 1) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 1);
    }
    else if (obj == 2) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 2);
    }
    else if (obj == 3) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 3);
    }
    else if (obj == 4) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 4);
    }
    else if (obj == 5) {
      tempItem = copyItems.filter((x: any) => x.TypeID == 5);
    }

    if(obj == 6) {
      if(this.selected.imp == 3){
        tempItem = copyItems        
      } else {
        tempItem = copyItems.filter((item: any) => item.ImportanceID == this.selected.imp)
      }
    }

    //If wiothout zero qty
    if (this.zeroQtyItems == false){
      tempItem = tempItem.filter((x: any) => x.CurrQty > 0);
    }
    //Deplited Filter
    if (this.depletedItems == true){
      tempItem = tempItem.filter((x: any) => x.CurrQty < x.MinStockQty);
    }

    //Category Filter
    if(this.data.categoryID > 0) {
        let tempCat = tempItem.filter((x: any) => x.CategoryID == this.data.categoryID);
        
        if(tempCat.length == 0){
          this.isDataFilter = true;
        }
        tempItem = tempCat;
    }

      //Sub Category 
      if(this.data.SubCategoryID > 0) {
        let subCatData = tempItem.filter((x: any) => x.SubCategoryID == this.data.SubCategoryID);
        
        if(subCatData.length == 0){
          this.isDataFilter = true;
        }
        tempItem = subCatData;
    }

      if (this.selectedTags.length > 0) {
        let tagArry = tempItem.filter((item: any) => {
            var tagArr = [];
            if (item.Tags) {
                tagArr = (item.Tags).split(',');
            }
            for (let i = 0; i < this.selectedTags.length; i++) {
                var existEle = tagArr.includes(this.selectedTags[i][0]);
                if (existEle) {
                    return item;
                }
            }
        });

        if (tagArry.length > 0){
          tempItem = tagArry;
        }
    }
   
    this.Items = tempItem;
    if(this.selected.imp != 3){
      this.Items = this.Items.filter((item: any) => item.ImportanceID == this.selected.imp);
    } 
    this.dataSource.data = this.Items;
    this.exportToExcel = this.Items;
    this.totalValue = 0;

    if (this.currValuation) {
      for (let i = 0; i < this.Items.length; i++) {
        //this.totalValue = this.totalValue + this.Items[i].TotalValue
        this.totalValue = (this.totalValue + (this.tagData[0].ValnMethod == 1 ? this.Items[i].ValStdCost : this.tagData[0].ValnMethod == 2 ? this.Items[i].ValLPP : this.Items[i].ValHistAvg));
      }
    } else {
      var total = this.Items.map((item: any) => Number(item.DefStockRate) * Number(item.CurrQty));
      this.totalValue = total.reduce(function (a: any, b: any) { return a + b; });
    }

    // let tempTotal = this.Items.reduce(this.Items[i].ValStdCost * this.Items[i].CurrQty)

  }


  //common search
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  opentagSearch(content: any) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'tagClass', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    });
  }



  selectStore(content: any) {
    //this.modalReference = this.modalService.open(content);

    //If can change store
    this.modalReference = this.modalService.open(SelectStoreComponent, { backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.StoreID = this.storeId;
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    if(!this.allStoreRights)  {
      this.modalReference.componentInstance.AllOption = 0; 
      this.modalReference.componentInstance.isShowAllOption = false;
    }
    this.modalReference.result.then((result: any) => {
      if (result) {
        if (result.length > 0) {
          this.storeId = result[0].StrID;
          this.storeName = result[0].sNm;
          this.getData();
        }
      }
    });
  }

  chagetagValue() {

    // let temptag = this.tag.filter((x: any) => x == this.Items.tag);
    // if (temptag.length > 0) {
    // } else {
    //   this.Items.tag = "";
    // }

    // if (this.Items.tag == null || this.Items.tag == undefined || this.Items.tag == 0) {
    //   alert("Please Select Tag");
    // } else {
    if (this.itemTag.search != '') {
      let temptag = this.tag.filter((x: any) => x == this.itemTag.search);
      if (temptag.length > 0) {

        let temptag1 = this.selectedTags.filter((x: any) => x == this.itemTag.search);
        if (temptag1.length == 0) {
          this.selectedTags.push(temptag);
        }
        // this.itemTag.search = "";
      }
    }

    //}
  }

  getTagSearchData(id: number) {

    if ((this.itemTag.search == "") && (id == 1)) {
      this.apiService.successAlert("Please Select Tag");
      return;
    } else {
      let temptag = this.tag.filter((x: any) => x == this.itemTag.search);
      if (temptag.length > 0) {

        let temptag1 = this.selectedTags.filter((x: any) => x == this.itemTag.search);
        if (temptag1.length == 0) {
          this.selectedTags.push(temptag);
          this.tag = this.tag.filter((b: any) => b != this.itemTag.search);
        }
        this.itemTag.search = "";
      }

      else {
        this.itemTag.search = "";
      }
    }

    if ((id == 2) && (this.itemTag.search != "")) {
      let temptag = this.tag.filter((x: any) => x == this.itemTag.search);
      if (temptag.length > 0) {

        let temptag1 = this.selectedTags.filter((x: any) => x == this.itemTag.search);
        if (temptag1.length == 0) {
          this.selectedTags.push(temptag);
          this.tag = this.tag.filter((b: any) => b != this.itemTag.search);
        }
        this.itemTag.search = "";
      }
      else {
        this.itemTag.search = "";
      }
    }
  }

  removeTagSearch = (index: any) => {
    let tmpTag = this.selectedTags.splice(index, 1).join(', ');
    //this.selectedTags.splice(index, 1);
    this.tag.push(tmpTag);
    this.tag = this.tag.sort((a: any, b: any) => a.localeCompare(b));
  }

  
  tagSearchItem(selectedTags:any) {
    if (selectedTags.length == 0) {
      this.modalReference.close();
      this.getData();
    } else {
    this.getTagSearchData(2);
    let filteredItems: any = [];

    this.Items.forEach((element: any) => {
      if (!Array.isArray(element.Tags)) {
        if (element.Tags != '') {
          element.Tags = element.Tags.split(',');
        }
      }
    });

    this.selectedTags = selectedTags;
    if (this.selectedTags.length > 0) {
      this.selectedTags.forEach((a: any) => {
        this.Items.forEach((b: any) => {
          if (b.Tags.length > 0) {
            b.Tags.forEach((c: any) => {
              if (a == c) {
                filteredItems.push(b);
              }
            });
          }
        });
      });
    }
    //  else {
    //   filteredItems = this.Items;
    // }
    this.modalReference.close();
    this.Items = filteredItems;
    this.dataSource.data = this.Items;
    this.exportToExcel = this.Items;
}
    //let selecttaglist = this.dataSource.filter((x: any) => x.ItemTags == this.selectedTags);
    //console.log(selecttaglist);

    // this.dataSource = new MatTableDataSource(filteredItems);
    // this.exportToExcel = filteredItems;

    // console.log(filteredItems);

    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.matSort;

    // this.modalReference.close();

  }


  filterApply() {
    this.getTagSearchData(2);
    this.typeFilter(this.filter);
    // if (this.modalReference){
    //   this.modalReference.close();
    // }
    return;
  }


  //depleted items
  filterDepleted() {
    // this.typeFilter(this.filter);
    // return;

    let tempdata = this.Items
    if (this.depletedItems) {
      let tempItems = tempdata.filter((x: any) => x.CurrQty < x.MinStockQty)
      this.Items = tempItems
      this.Items = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))

      this.dataSource.data = this.Items
      this.exportToExcel = this.Items

      

      var total = this.Items.map((item: any) => item.ValStdCost * item.CurrQty);
      this.totalValue = total.reduce(function (a: any, b: any) { return a + b; });
      //  this.exportToExcel = this.Items
      //this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = this.createFilter();
    }
    else {
      this.Items = this.copyItems
      this.Items = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))

      this.dataSource.data = this.Items
      var total = this.Items.map((item: any) => item.ValStdCost * item.CurrQty);
      this.totalValue = total.reduce(function (a: any, b: any) { return a + b; });
       this.exportToExcel = this.Items
      //this.dataSource.sort = this.sort;
      // this.dataSource.filterPredicate = this.createFilter();
    }
  }

  //depleted items
  filterIncludeZeroqty() {
    this.typeFilter(this.filter);
    return;

    if (this.zeroQtyItems) {
      this.IncludeZeroqtyItms = this.IncludeZeroqtyItms.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName))
      this.dataSource.data = this.IncludeZeroqtyItms;
      // this.exportToExcel = this.IncludeZeroqtyItms;
      this.Items = this.IncludeZeroqtyItms;
      //this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = this.createFilter();
    }
    else {
      this.Items = this.copyItems;
      this.Items = this.Items.sort((a: any, b: any) => a.ItemName.localeCompare(b.ItemName));

      this.dataSource.data = this.Items;
      this.exportToExcel = this.Items;
      //this.dataSource.sort = this.sort;
      //this.dataSource.filterPredicate = this.createFilter();
    }
  }
  //filterSubCategory() - Get sub category List from category - Case cading
filterCategory = () => {

  this.subCategoryList = [];
 
  let subCat: any = this.categories.filter((x: any) => x.cid == this.data.categoryID);
  if(subCat.length > 0){
    if (subCat[0].sub) {
        this.subCategoryList = (subCat[0].sub);
    }
    else {
        this.data.SubCategoryID = "0";
        this.data.subCategory = '';
    }
  }
  this.filterApply();
  return;
}

//select subCategory
 filterSubCategory = () => {
  setTimeout(() => {
  let tempsubCat: any = [];
 
  if (this.data.subCategory) {
    let tempsubCat: any = [];
    tempsubCat = this.subCategoryList.filter((x: any) => x.snm == this.data.subCategory)
  
    if (tempsubCat.length > 0) {
      this.data.SubCategoryID = tempsubCat[0].sid
    }
    else {
      this.apiService.successAlert("Please configure item categories.")
      this.data.subCategory = '';
      this.data.SubCategoryID = 0;

    }
  }
  this.filterApply();
}, 200);
}
 


  backBtn() {
    window.history.back();
  }

  changeStore(){
    let store = this.storeList.find((store: any) => store.StrID == this.storeId);
    if(store){
      this.storeId = store.StrID;
      this.storeName = store.sNm;
    }
    else{
      this.storeId = 0;
      this.storeName = "All Stores";
    }
    this.getData();
  }

  filterStockItems(){
    switch (Number(this.selected.stockType)) {
      case 0:
        this.depletedItems = false;
        this.zeroQtyItems = false;
        break;
      case 1:
        this.depletedItems = false;
        this.zeroQtyItems = true;
        break;
      case 2:
        this.depletedItems = true;
        this.zeroQtyItems = true;
        break;
      }
      this.typeFilter(this.filter);
    }

  removeTagSearchNew(i: number){
    this.removeTagSearch(i);
    this.filterApply();
  }

  // Open Help Page
  openHelpPage(id: any) {
    this.CmnService.openModulHelp(id, this.isWeb);
  }
}
function n(arg0: number, n: any) {
  throw new Error('Function not implemented.');
}

